import * as O from "react";
import se from "react";
var ge = { exports: {} }, T = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var ae;
function Ge() {
  if (ae) return T;
  ae = 1;
  var s = se, e = Symbol.for("react.element"), t = Symbol.for("react.fragment"), r = Object.prototype.hasOwnProperty, n = s.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, i = { key: !0, ref: !0, __self: !0, __source: !0 };
  function u(a, c, l) {
    var h, d = {}, f = null, o = null;
    l !== void 0 && (f = "" + l), c.key !== void 0 && (f = "" + c.key), c.ref !== void 0 && (o = c.ref);
    for (h in c) r.call(c, h) && !i.hasOwnProperty(h) && (d[h] = c[h]);
    if (a && a.defaultProps) for (h in c = a.defaultProps, c) d[h] === void 0 && (d[h] = c[h]);
    return { $$typeof: e, type: a, key: f, ref: o, props: d, _owner: n.current };
  }
  return T.Fragment = t, T.jsx = u, T.jsxs = u, T;
}
ge.exports = Ge();
var z = ge.exports;
class x {
  constructor() {
    this.listeners = /* @__PURE__ */ new Set(), this.subscribe = this.subscribe.bind(this);
  }
  subscribe(e) {
    const t = {
      listener: e
    };
    return this.listeners.add(t), this.onSubscribe(), () => {
      this.listeners.delete(t), this.onUnsubscribe();
    };
  }
  hasListeners() {
    return this.listeners.size > 0;
  }
  onSubscribe() {
  }
  onUnsubscribe() {
  }
}
const K = typeof window > "u" || "Deno" in window;
function w() {
}
function ze(s, e) {
  return typeof s == "function" ? s(e) : s;
}
function J(s) {
  return typeof s == "number" && s >= 0 && s !== 1 / 0;
}
function oe(s, e) {
  return s.filter((t) => !e.includes(t));
}
function Ve(s, e, t) {
  const r = s.slice(0);
  return r[e] = t, r;
}
function Oe(s, e) {
  return Math.max(s + (e || 0) - Date.now(), 0);
}
function D(s, e, t) {
  return A(s) ? typeof e == "function" ? {
    ...t,
    queryKey: s,
    queryFn: e
  } : {
    ...e,
    queryKey: s
  } : s;
}
function Je(s, e, t) {
  return A(s) ? typeof e == "function" ? {
    ...t,
    mutationKey: s,
    mutationFn: e
  } : {
    ...e,
    mutationKey: s
  } : typeof s == "function" ? {
    ...e,
    mutationFn: s
  } : {
    ...s
  };
}
function F(s, e, t) {
  return A(s) ? [{
    ...e,
    queryKey: s
  }, t] : [s || {}, e];
}
function We(s, e, t) {
  return A(s) ? [{
    ...e,
    mutationKey: s
  }, t] : [s || {}, e];
}
function ce(s, e) {
  const {
    type: t = "all",
    exact: r,
    fetchStatus: n,
    predicate: i,
    queryKey: u,
    stale: a
  } = s;
  if (A(u)) {
    if (r) {
      if (e.queryHash !== re(u, e.options))
        return !1;
    } else if (!k(e.queryKey, u))
      return !1;
  }
  if (t !== "all") {
    const c = e.isActive();
    if (t === "active" && !c || t === "inactive" && c)
      return !1;
  }
  return !(typeof a == "boolean" && e.isStale() !== a || typeof n < "u" && n !== e.state.fetchStatus || i && !i(e));
}
function le(s, e) {
  const {
    exact: t,
    fetching: r,
    predicate: n,
    mutationKey: i
  } = s;
  if (A(i)) {
    if (!e.options.mutationKey)
      return !1;
    if (t) {
      if (q(e.options.mutationKey) !== q(i))
        return !1;
    } else if (!k(e.options.mutationKey, i))
      return !1;
  }
  return !(typeof r == "boolean" && e.state.status === "loading" !== r || n && !n(e));
}
function re(s, e) {
  return ((e == null ? void 0 : e.queryKeyHashFn) || q)(s);
}
function q(s) {
  return JSON.stringify(s, (e, t) => W(t) ? Object.keys(t).sort().reduce((r, n) => (r[n] = t[n], r), {}) : t);
}
function k(s, e) {
  return Re(s, e);
}
function Re(s, e) {
  return s === e ? !0 : typeof s != typeof e ? !1 : s && e && typeof s == "object" && typeof e == "object" ? !Object.keys(e).some((t) => !Re(s[t], e[t])) : !1;
}
function Ce(s, e) {
  if (s === e)
    return s;
  const t = he(s) && he(e);
  if (t || W(s) && W(e)) {
    const r = t ? s.length : Object.keys(s).length, n = t ? e : Object.keys(e), i = n.length, u = t ? [] : {};
    let a = 0;
    for (let c = 0; c < i; c++) {
      const l = t ? c : n[c];
      u[l] = Ce(s[l], e[l]), u[l] === s[l] && a++;
    }
    return r === i && a === r ? s : u;
  }
  return e;
}
function j(s, e) {
  if (s && !e || e && !s)
    return !1;
  for (const t in s)
    if (s[t] !== e[t])
      return !1;
  return !0;
}
function he(s) {
  return Array.isArray(s) && s.length === Object.keys(s).length;
}
function W(s) {
  if (!de(s))
    return !1;
  const e = s.constructor;
  if (typeof e > "u")
    return !0;
  const t = e.prototype;
  return !(!de(t) || !t.hasOwnProperty("isPrototypeOf"));
}
function de(s) {
  return Object.prototype.toString.call(s) === "[object Object]";
}
function A(s) {
  return Array.isArray(s);
}
function qt(s) {
  return s instanceof Error;
}
function Pe(s) {
  return new Promise((e) => {
    setTimeout(e, s);
  });
}
function fe(s) {
  Pe(0).then(s);
}
function Ye() {
  if (typeof AbortController == "function")
    return new AbortController();
}
function Y(s, e, t) {
  return t.isDataEqual != null && t.isDataEqual(s, e) ? s : typeof t.structuralSharing == "function" ? t.structuralSharing(s, e) : t.structuralSharing !== !1 ? Ce(s, e) : e;
}
class Xe extends x {
  constructor() {
    super(), this.setup = (e) => {
      if (!K && window.addEventListener) {
        const t = () => e();
        return window.addEventListener("visibilitychange", t, !1), window.addEventListener("focus", t, !1), () => {
          window.removeEventListener("visibilitychange", t), window.removeEventListener("focus", t);
        };
      }
    };
  }
  onSubscribe() {
    this.cleanup || this.setEventListener(this.setup);
  }
  onUnsubscribe() {
    if (!this.hasListeners()) {
      var e;
      (e = this.cleanup) == null || e.call(this), this.cleanup = void 0;
    }
  }
  setEventListener(e) {
    var t;
    this.setup = e, (t = this.cleanup) == null || t.call(this), this.cleanup = e((r) => {
      typeof r == "boolean" ? this.setFocused(r) : this.onFocus();
    });
  }
  setFocused(e) {
    this.focused !== e && (this.focused = e, this.onFocus());
  }
  onFocus() {
    this.listeners.forEach(({
      listener: e
    }) => {
      e();
    });
  }
  isFocused() {
    return typeof this.focused == "boolean" ? this.focused : typeof document > "u" ? !0 : [void 0, "visible", "prerender"].includes(document.visibilityState);
  }
}
const N = new Xe(), ye = ["online", "offline"];
class Ze extends x {
  constructor() {
    super(), this.setup = (e) => {
      if (!K && window.addEventListener) {
        const t = () => e();
        return ye.forEach((r) => {
          window.addEventListener(r, t, !1);
        }), () => {
          ye.forEach((r) => {
            window.removeEventListener(r, t);
          });
        };
      }
    };
  }
  onSubscribe() {
    this.cleanup || this.setEventListener(this.setup);
  }
  onUnsubscribe() {
    if (!this.hasListeners()) {
      var e;
      (e = this.cleanup) == null || e.call(this), this.cleanup = void 0;
    }
  }
  setEventListener(e) {
    var t;
    this.setup = e, (t = this.cleanup) == null || t.call(this), this.cleanup = e((r) => {
      typeof r == "boolean" ? this.setOnline(r) : this.onOnline();
    });
  }
  setOnline(e) {
    this.online !== e && (this.online = e, this.onOnline());
  }
  onOnline() {
    this.listeners.forEach(({
      listener: e
    }) => {
      e();
    });
  }
  isOnline() {
    return typeof this.online == "boolean" ? this.online : typeof navigator > "u" || typeof navigator.onLine > "u" ? !0 : navigator.onLine;
  }
}
const H = new Ze();
function $e(s) {
  return Math.min(1e3 * 2 ** s, 3e4);
}
function B(s) {
  return (s ?? "online") === "online" ? H.isOnline() : !0;
}
class Se {
  constructor(e) {
    this.revert = e == null ? void 0 : e.revert, this.silent = e == null ? void 0 : e.silent;
  }
}
function _(s) {
  return s instanceof Se;
}
function Qe(s) {
  let e = !1, t = 0, r = !1, n, i, u;
  const a = new Promise((v, C) => {
    i = v, u = C;
  }), c = (v) => {
    r || (o(new Se(v)), s.abort == null || s.abort());
  }, l = () => {
    e = !0;
  }, h = () => {
    e = !1;
  }, d = () => !N.isFocused() || s.networkMode !== "always" && !H.isOnline(), f = (v) => {
    r || (r = !0, s.onSuccess == null || s.onSuccess(v), n == null || n(), i(v));
  }, o = (v) => {
    r || (r = !0, s.onError == null || s.onError(v), n == null || n(), u(v));
  }, y = () => new Promise((v) => {
    n = (C) => {
      const Q = r || !d();
      return Q && v(C), Q;
    }, s.onPause == null || s.onPause();
  }).then(() => {
    n = void 0, r || s.onContinue == null || s.onContinue();
  }), p = () => {
    if (r)
      return;
    let v;
    try {
      v = s.fn();
    } catch (C) {
      v = Promise.reject(C);
    }
    Promise.resolve(v).then(f).catch((C) => {
      var Q, P;
      if (r)
        return;
      const S = (Q = s.retry) != null ? Q : 3, M = (P = s.retryDelay) != null ? P : $e, g = typeof M == "function" ? M(t, C) : M, b = S === !0 || typeof S == "number" && t < S || typeof S == "function" && S(t, C);
      if (e || !b) {
        o(C);
        return;
      }
      t++, s.onFail == null || s.onFail(t, C), Pe(g).then(() => {
        if (d())
          return y();
      }).then(() => {
        e ? o(C) : p();
      });
    });
  };
  return B(s.networkMode) ? p() : y().then(p), {
    promise: a,
    cancel: c,
    continue: () => (n == null ? void 0 : n()) ? a : Promise.resolve(),
    cancelRetry: l,
    continueRetry: h
  };
}
const ie = console;
function et() {
  let s = [], e = 0, t = (h) => {
    h();
  }, r = (h) => {
    h();
  };
  const n = (h) => {
    let d;
    e++;
    try {
      d = h();
    } finally {
      e--, e || a();
    }
    return d;
  }, i = (h) => {
    e ? s.push(h) : fe(() => {
      t(h);
    });
  }, u = (h) => (...d) => {
    i(() => {
      h(...d);
    });
  }, a = () => {
    const h = s;
    s = [], h.length && fe(() => {
      r(() => {
        h.forEach((d) => {
          t(d);
        });
      });
    });
  };
  return {
    batch: n,
    batchCalls: u,
    schedule: i,
    setNotifyFunction: (h) => {
      t = h;
    },
    setBatchNotifyFunction: (h) => {
      r = h;
    }
  };
}
const R = et();
class Ee {
  destroy() {
    this.clearGcTimeout();
  }
  scheduleGc() {
    this.clearGcTimeout(), J(this.cacheTime) && (this.gcTimeout = setTimeout(() => {
      this.optionalRemove();
    }, this.cacheTime));
  }
  updateCacheTime(e) {
    this.cacheTime = Math.max(this.cacheTime || 0, e ?? (K ? 1 / 0 : 5 * 60 * 1e3));
  }
  clearGcTimeout() {
    this.gcTimeout && (clearTimeout(this.gcTimeout), this.gcTimeout = void 0);
  }
}
class tt extends Ee {
  constructor(e) {
    super(), this.abortSignalConsumed = !1, this.defaultOptions = e.defaultOptions, this.setOptions(e.options), this.observers = [], this.cache = e.cache, this.logger = e.logger || ie, this.queryKey = e.queryKey, this.queryHash = e.queryHash, this.initialState = e.state || st(this.options), this.state = this.initialState, this.scheduleGc();
  }
  get meta() {
    return this.options.meta;
  }
  setOptions(e) {
    this.options = {
      ...this.defaultOptions,
      ...e
    }, this.updateCacheTime(this.options.cacheTime);
  }
  optionalRemove() {
    !this.observers.length && this.state.fetchStatus === "idle" && this.cache.remove(this);
  }
  setData(e, t) {
    const r = Y(this.state.data, e, this.options);
    return this.dispatch({
      data: r,
      type: "success",
      dataUpdatedAt: t == null ? void 0 : t.updatedAt,
      manual: t == null ? void 0 : t.manual
    }), r;
  }
  setState(e, t) {
    this.dispatch({
      type: "setState",
      state: e,
      setStateOptions: t
    });
  }
  cancel(e) {
    var t;
    const r = this.promise;
    return (t = this.retryer) == null || t.cancel(e), r ? r.then(w).catch(w) : Promise.resolve();
  }
  destroy() {
    super.destroy(), this.cancel({
      silent: !0
    });
  }
  reset() {
    this.destroy(), this.setState(this.initialState);
  }
  isActive() {
    return this.observers.some((e) => e.options.enabled !== !1);
  }
  isDisabled() {
    return this.getObserversCount() > 0 && !this.isActive();
  }
  isStale() {
    return this.state.isInvalidated || !this.state.dataUpdatedAt || this.observers.some((e) => e.getCurrentResult().isStale);
  }
  isStaleByTime(e = 0) {
    return this.state.isInvalidated || !this.state.dataUpdatedAt || !Oe(this.state.dataUpdatedAt, e);
  }
  onFocus() {
    var e;
    const t = this.observers.find((r) => r.shouldFetchOnWindowFocus());
    t && t.refetch({
      cancelRefetch: !1
    }), (e = this.retryer) == null || e.continue();
  }
  onOnline() {
    var e;
    const t = this.observers.find((r) => r.shouldFetchOnReconnect());
    t && t.refetch({
      cancelRefetch: !1
    }), (e = this.retryer) == null || e.continue();
  }
  addObserver(e) {
    this.observers.includes(e) || (this.observers.push(e), this.clearGcTimeout(), this.cache.notify({
      type: "observerAdded",
      query: this,
      observer: e
    }));
  }
  removeObserver(e) {
    this.observers.includes(e) && (this.observers = this.observers.filter((t) => t !== e), this.observers.length || (this.retryer && (this.abortSignalConsumed ? this.retryer.cancel({
      revert: !0
    }) : this.retryer.cancelRetry()), this.scheduleGc()), this.cache.notify({
      type: "observerRemoved",
      query: this,
      observer: e
    }));
  }
  getObserversCount() {
    return this.observers.length;
  }
  invalidate() {
    this.state.isInvalidated || this.dispatch({
      type: "invalidate"
    });
  }
  fetch(e, t) {
    var r, n;
    if (this.state.fetchStatus !== "idle") {
      if (this.state.dataUpdatedAt && t != null && t.cancelRefetch)
        this.cancel({
          silent: !0
        });
      else if (this.promise) {
        var i;
        return (i = this.retryer) == null || i.continueRetry(), this.promise;
      }
    }
    if (e && this.setOptions(e), !this.options.queryFn) {
      const o = this.observers.find((y) => y.options.queryFn);
      o && this.setOptions(o.options);
    }
    const u = Ye(), a = {
      queryKey: this.queryKey,
      pageParam: void 0,
      meta: this.meta
    }, c = (o) => {
      Object.defineProperty(o, "signal", {
        enumerable: !0,
        get: () => {
          if (u)
            return this.abortSignalConsumed = !0, u.signal;
        }
      });
    };
    c(a);
    const l = () => this.options.queryFn ? (this.abortSignalConsumed = !1, this.options.queryFn(a)) : Promise.reject("Missing queryFn for queryKey '" + this.options.queryHash + "'"), h = {
      fetchOptions: t,
      options: this.options,
      queryKey: this.queryKey,
      state: this.state,
      fetchFn: l
    };
    if (c(h), (r = this.options.behavior) == null || r.onFetch(h), this.revertState = this.state, this.state.fetchStatus === "idle" || this.state.fetchMeta !== ((n = h.fetchOptions) == null ? void 0 : n.meta)) {
      var d;
      this.dispatch({
        type: "fetch",
        meta: (d = h.fetchOptions) == null ? void 0 : d.meta
      });
    }
    const f = (o) => {
      if (_(o) && o.silent || this.dispatch({
        type: "error",
        error: o
      }), !_(o)) {
        var y, p, v, C;
        (y = (p = this.cache.config).onError) == null || y.call(p, o, this), (v = (C = this.cache.config).onSettled) == null || v.call(C, this.state.data, o, this);
      }
      this.isFetchingOptimistic || this.scheduleGc(), this.isFetchingOptimistic = !1;
    };
    return this.retryer = Qe({
      fn: h.fetchFn,
      abort: u == null ? void 0 : u.abort.bind(u),
      onSuccess: (o) => {
        var y, p, v, C;
        if (typeof o > "u") {
          f(new Error(this.queryHash + " data is undefined"));
          return;
        }
        this.setData(o), (y = (p = this.cache.config).onSuccess) == null || y.call(p, o, this), (v = (C = this.cache.config).onSettled) == null || v.call(C, o, this.state.error, this), this.isFetchingOptimistic || this.scheduleGc(), this.isFetchingOptimistic = !1;
      },
      onError: f,
      onFail: (o, y) => {
        this.dispatch({
          type: "failed",
          failureCount: o,
          error: y
        });
      },
      onPause: () => {
        this.dispatch({
          type: "pause"
        });
      },
      onContinue: () => {
        this.dispatch({
          type: "continue"
        });
      },
      retry: h.options.retry,
      retryDelay: h.options.retryDelay,
      networkMode: h.options.networkMode
    }), this.promise = this.retryer.promise, this.promise;
  }
  dispatch(e) {
    const t = (r) => {
      var n, i;
      switch (e.type) {
        case "failed":
          return {
            ...r,
            fetchFailureCount: e.failureCount,
            fetchFailureReason: e.error
          };
        case "pause":
          return {
            ...r,
            fetchStatus: "paused"
          };
        case "continue":
          return {
            ...r,
            fetchStatus: "fetching"
          };
        case "fetch":
          return {
            ...r,
            fetchFailureCount: 0,
            fetchFailureReason: null,
            fetchMeta: (n = e.meta) != null ? n : null,
            fetchStatus: B(this.options.networkMode) ? "fetching" : "paused",
            ...!r.dataUpdatedAt && {
              error: null,
              status: "loading"
            }
          };
        case "success":
          return {
            ...r,
            data: e.data,
            dataUpdateCount: r.dataUpdateCount + 1,
            dataUpdatedAt: (i = e.dataUpdatedAt) != null ? i : Date.now(),
            error: null,
            isInvalidated: !1,
            status: "success",
            ...!e.manual && {
              fetchStatus: "idle",
              fetchFailureCount: 0,
              fetchFailureReason: null
            }
          };
        case "error":
          const u = e.error;
          return _(u) && u.revert && this.revertState ? {
            ...this.revertState,
            fetchStatus: "idle"
          } : {
            ...r,
            error: u,
            errorUpdateCount: r.errorUpdateCount + 1,
            errorUpdatedAt: Date.now(),
            fetchFailureCount: r.fetchFailureCount + 1,
            fetchFailureReason: u,
            fetchStatus: "idle",
            status: "error"
          };
        case "invalidate":
          return {
            ...r,
            isInvalidated: !0
          };
        case "setState":
          return {
            ...r,
            ...e.state
          };
      }
    };
    this.state = t(this.state), R.batch(() => {
      this.observers.forEach((r) => {
        r.onQueryUpdate(e);
      }), this.cache.notify({
        query: this,
        type: "updated",
        action: e
      });
    });
  }
}
function st(s) {
  const e = typeof s.initialData == "function" ? s.initialData() : s.initialData, t = typeof e < "u", r = t ? typeof s.initialDataUpdatedAt == "function" ? s.initialDataUpdatedAt() : s.initialDataUpdatedAt : 0;
  return {
    data: e,
    dataUpdateCount: 0,
    dataUpdatedAt: t ? r ?? Date.now() : 0,
    error: null,
    errorUpdateCount: 0,
    errorUpdatedAt: 0,
    fetchFailureCount: 0,
    fetchFailureReason: null,
    fetchMeta: null,
    isInvalidated: !1,
    status: t ? "success" : "loading",
    fetchStatus: "idle"
  };
}
class rt extends x {
  constructor(e) {
    super(), this.config = e || {}, this.queries = [], this.queriesMap = {};
  }
  build(e, t, r) {
    var n;
    const i = t.queryKey, u = (n = t.queryHash) != null ? n : re(i, t);
    let a = this.get(u);
    return a || (a = new tt({
      cache: this,
      logger: e.getLogger(),
      queryKey: i,
      queryHash: u,
      options: e.defaultQueryOptions(t),
      state: r,
      defaultOptions: e.getQueryDefaults(i)
    }), this.add(a)), a;
  }
  add(e) {
    this.queriesMap[e.queryHash] || (this.queriesMap[e.queryHash] = e, this.queries.push(e), this.notify({
      type: "added",
      query: e
    }));
  }
  remove(e) {
    const t = this.queriesMap[e.queryHash];
    t && (e.destroy(), this.queries = this.queries.filter((r) => r !== e), t === e && delete this.queriesMap[e.queryHash], this.notify({
      type: "removed",
      query: e
    }));
  }
  clear() {
    R.batch(() => {
      this.queries.forEach((e) => {
        this.remove(e);
      });
    });
  }
  get(e) {
    return this.queriesMap[e];
  }
  getAll() {
    return this.queries;
  }
  find(e, t) {
    const [r] = F(e, t);
    return typeof r.exact > "u" && (r.exact = !0), this.queries.find((n) => ce(r, n));
  }
  findAll(e, t) {
    const [r] = F(e, t);
    return Object.keys(r).length > 0 ? this.queries.filter((n) => ce(r, n)) : this.queries;
  }
  notify(e) {
    R.batch(() => {
      this.listeners.forEach(({
        listener: t
      }) => {
        t(e);
      });
    });
  }
  onFocus() {
    R.batch(() => {
      this.queries.forEach((e) => {
        e.onFocus();
      });
    });
  }
  onOnline() {
    R.batch(() => {
      this.queries.forEach((e) => {
        e.onOnline();
      });
    });
  }
}
var it = { NODE_ENV: "production" };
class nt extends Ee {
  constructor(e) {
    super(), this.defaultOptions = e.defaultOptions, this.mutationId = e.mutationId, this.mutationCache = e.mutationCache, this.logger = e.logger || ie, this.observers = [], this.state = e.state || we(), this.setOptions(e.options), this.scheduleGc();
  }
  setOptions(e) {
    this.options = {
      ...this.defaultOptions,
      ...e
    }, this.updateCacheTime(this.options.cacheTime);
  }
  get meta() {
    return this.options.meta;
  }
  setState(e) {
    this.dispatch({
      type: "setState",
      state: e
    });
  }
  addObserver(e) {
    this.observers.includes(e) || (this.observers.push(e), this.clearGcTimeout(), this.mutationCache.notify({
      type: "observerAdded",
      mutation: this,
      observer: e
    }));
  }
  removeObserver(e) {
    this.observers = this.observers.filter((t) => t !== e), this.scheduleGc(), this.mutationCache.notify({
      type: "observerRemoved",
      mutation: this,
      observer: e
    });
  }
  optionalRemove() {
    this.observers.length || (this.state.status === "loading" ? this.scheduleGc() : this.mutationCache.remove(this));
  }
  continue() {
    var e, t;
    return (e = (t = this.retryer) == null ? void 0 : t.continue()) != null ? e : this.execute();
  }
  async execute() {
    const e = () => {
      var b;
      return this.retryer = Qe({
        fn: () => this.options.mutationFn ? this.options.mutationFn(this.state.variables) : Promise.reject("No mutationFn found"),
        onFail: (m, E) => {
          this.dispatch({
            type: "failed",
            failureCount: m,
            error: E
          });
        },
        onPause: () => {
          this.dispatch({
            type: "pause"
          });
        },
        onContinue: () => {
          this.dispatch({
            type: "continue"
          });
        },
        retry: (b = this.options.retry) != null ? b : 0,
        retryDelay: this.options.retryDelay,
        networkMode: this.options.networkMode
      }), this.retryer.promise;
    }, t = this.state.status === "loading";
    try {
      var r, n, i, u, a, c, l, h;
      if (!t) {
        var d, f, o, y;
        this.dispatch({
          type: "loading",
          variables: this.options.variables
        }), await ((d = (f = this.mutationCache.config).onMutate) == null ? void 0 : d.call(f, this.state.variables, this));
        const m = await ((o = (y = this.options).onMutate) == null ? void 0 : o.call(y, this.state.variables));
        m !== this.state.context && this.dispatch({
          type: "loading",
          context: m,
          variables: this.state.variables
        });
      }
      const b = await e();
      return await ((r = (n = this.mutationCache.config).onSuccess) == null ? void 0 : r.call(n, b, this.state.variables, this.state.context, this)), await ((i = (u = this.options).onSuccess) == null ? void 0 : i.call(u, b, this.state.variables, this.state.context)), await ((a = (c = this.mutationCache.config).onSettled) == null ? void 0 : a.call(c, b, null, this.state.variables, this.state.context, this)), await ((l = (h = this.options).onSettled) == null ? void 0 : l.call(h, b, null, this.state.variables, this.state.context)), this.dispatch({
        type: "success",
        data: b
      }), b;
    } catch (b) {
      try {
        var p, v, C, Q, P, S, M, g;
        throw await ((p = (v = this.mutationCache.config).onError) == null ? void 0 : p.call(v, b, this.state.variables, this.state.context, this)), it.NODE_ENV, await ((C = (Q = this.options).onError) == null ? void 0 : C.call(Q, b, this.state.variables, this.state.context)), await ((P = (S = this.mutationCache.config).onSettled) == null ? void 0 : P.call(S, void 0, b, this.state.variables, this.state.context, this)), await ((M = (g = this.options).onSettled) == null ? void 0 : M.call(g, void 0, b, this.state.variables, this.state.context)), b;
      } finally {
        this.dispatch({
          type: "error",
          error: b
        });
      }
    }
  }
  dispatch(e) {
    const t = (r) => {
      switch (e.type) {
        case "failed":
          return {
            ...r,
            failureCount: e.failureCount,
            failureReason: e.error
          };
        case "pause":
          return {
            ...r,
            isPaused: !0
          };
        case "continue":
          return {
            ...r,
            isPaused: !1
          };
        case "loading":
          return {
            ...r,
            context: e.context,
            data: void 0,
            failureCount: 0,
            failureReason: null,
            error: null,
            isPaused: !B(this.options.networkMode),
            status: "loading",
            variables: e.variables
          };
        case "success":
          return {
            ...r,
            data: e.data,
            failureCount: 0,
            failureReason: null,
            error: null,
            status: "success",
            isPaused: !1
          };
        case "error":
          return {
            ...r,
            data: void 0,
            error: e.error,
            failureCount: r.failureCount + 1,
            failureReason: e.error,
            isPaused: !1,
            status: "error"
          };
        case "setState":
          return {
            ...r,
            ...e.state
          };
      }
    };
    this.state = t(this.state), R.batch(() => {
      this.observers.forEach((r) => {
        r.onMutationUpdate(e);
      }), this.mutationCache.notify({
        mutation: this,
        type: "updated",
        action: e
      });
    });
  }
}
function we() {
  return {
    context: void 0,
    data: void 0,
    error: null,
    failureCount: 0,
    failureReason: null,
    isPaused: !1,
    status: "idle",
    variables: void 0
  };
}
class ut extends x {
  constructor(e) {
    super(), this.config = e || {}, this.mutations = [], this.mutationId = 0;
  }
  build(e, t, r) {
    const n = new nt({
      mutationCache: this,
      logger: e.getLogger(),
      mutationId: ++this.mutationId,
      options: e.defaultMutationOptions(t),
      state: r,
      defaultOptions: t.mutationKey ? e.getMutationDefaults(t.mutationKey) : void 0
    });
    return this.add(n), n;
  }
  add(e) {
    this.mutations.push(e), this.notify({
      type: "added",
      mutation: e
    });
  }
  remove(e) {
    this.mutations = this.mutations.filter((t) => t !== e), this.notify({
      type: "removed",
      mutation: e
    });
  }
  clear() {
    R.batch(() => {
      this.mutations.forEach((e) => {
        this.remove(e);
      });
    });
  }
  getAll() {
    return this.mutations;
  }
  find(e) {
    return typeof e.exact > "u" && (e.exact = !0), this.mutations.find((t) => le(e, t));
  }
  findAll(e) {
    return this.mutations.filter((t) => le(e, t));
  }
  notify(e) {
    R.batch(() => {
      this.listeners.forEach(({
        listener: t
      }) => {
        t(e);
      });
    });
  }
  resumePausedMutations() {
    var e;
    return this.resuming = ((e = this.resuming) != null ? e : Promise.resolve()).then(() => {
      const t = this.mutations.filter((r) => r.state.isPaused);
      return R.batch(() => t.reduce((r, n) => r.then(() => n.continue().catch(w)), Promise.resolve()));
    }).then(() => {
      this.resuming = void 0;
    }), this.resuming;
  }
}
function X() {
  return {
    onFetch: (s) => {
      s.fetchFn = () => {
        var e, t, r, n, i, u;
        const a = (e = s.fetchOptions) == null || (t = e.meta) == null ? void 0 : t.refetchPage, c = (r = s.fetchOptions) == null || (n = r.meta) == null ? void 0 : n.fetchMore, l = c == null ? void 0 : c.pageParam, h = (c == null ? void 0 : c.direction) === "forward", d = (c == null ? void 0 : c.direction) === "backward", f = ((i = s.state.data) == null ? void 0 : i.pages) || [], o = ((u = s.state.data) == null ? void 0 : u.pageParams) || [];
        let y = o, p = !1;
        const v = (g) => {
          Object.defineProperty(g, "signal", {
            enumerable: !0,
            get: () => {
              var b;
              if ((b = s.signal) != null && b.aborted)
                p = !0;
              else {
                var m;
                (m = s.signal) == null || m.addEventListener("abort", () => {
                  p = !0;
                });
              }
              return s.signal;
            }
          });
        }, C = s.options.queryFn || (() => Promise.reject("Missing queryFn for queryKey '" + s.options.queryHash + "'")), Q = (g, b, m, E) => (y = E ? [b, ...y] : [...y, b], E ? [m, ...g] : [...g, m]), P = (g, b, m, E) => {
          if (p)
            return Promise.reject("Cancelled");
          if (typeof m > "u" && !b && g.length)
            return Promise.resolve(g);
          const U = {
            queryKey: s.queryKey,
            pageParam: m,
            meta: s.options.meta
          };
          v(U);
          const G = C(U);
          return Promise.resolve(G).then((Be) => Q(g, m, Be, E));
        };
        let S;
        if (!f.length)
          S = P([]);
        else if (h) {
          const g = typeof l < "u", b = g ? l : Z(s.options, f);
          S = P(f, g, b);
        } else if (d) {
          const g = typeof l < "u", b = g ? l : Me(s.options, f);
          S = P(f, g, b, !0);
        } else {
          y = [];
          const g = typeof s.options.getNextPageParam > "u";
          S = (a && f[0] ? a(f[0], 0, f) : !0) ? P([], g, o[0]) : Promise.resolve(Q([], o[0], f[0]));
          for (let m = 1; m < f.length; m++)
            S = S.then((E) => {
              if (a && f[m] ? a(f[m], m, f) : !0) {
                const G = g ? o[m] : Z(s.options, E);
                return P(E, g, G);
              }
              return Promise.resolve(Q(E, o[m], f[m]));
            });
        }
        return S.then((g) => ({
          pages: g,
          pageParams: y
        }));
      };
    }
  };
}
function Z(s, e) {
  return s.getNextPageParam == null ? void 0 : s.getNextPageParam(e[e.length - 1], e);
}
function Me(s, e) {
  return s.getPreviousPageParam == null ? void 0 : s.getPreviousPageParam(e[0], e);
}
function at(s, e) {
  if (s.getNextPageParam && Array.isArray(e)) {
    const t = Z(s, e);
    return typeof t < "u" && t !== null && t !== !1;
  }
}
function ot(s, e) {
  if (s.getPreviousPageParam && Array.isArray(e)) {
    const t = Me(s, e);
    return typeof t < "u" && t !== null && t !== !1;
  }
}
class xt {
  constructor(e = {}) {
    this.queryCache = e.queryCache || new rt(), this.mutationCache = e.mutationCache || new ut(), this.logger = e.logger || ie, this.defaultOptions = e.defaultOptions || {}, this.queryDefaults = [], this.mutationDefaults = [], this.mountCount = 0;
  }
  mount() {
    this.mountCount++, this.mountCount === 1 && (this.unsubscribeFocus = N.subscribe(() => {
      N.isFocused() && (this.resumePausedMutations(), this.queryCache.onFocus());
    }), this.unsubscribeOnline = H.subscribe(() => {
      H.isOnline() && (this.resumePausedMutations(), this.queryCache.onOnline());
    }));
  }
  unmount() {
    var e, t;
    this.mountCount--, this.mountCount === 0 && ((e = this.unsubscribeFocus) == null || e.call(this), this.unsubscribeFocus = void 0, (t = this.unsubscribeOnline) == null || t.call(this), this.unsubscribeOnline = void 0);
  }
  isFetching(e, t) {
    const [r] = F(e, t);
    return r.fetchStatus = "fetching", this.queryCache.findAll(r).length;
  }
  isMutating(e) {
    return this.mutationCache.findAll({
      ...e,
      fetching: !0
    }).length;
  }
  getQueryData(e, t) {
    var r;
    return (r = this.queryCache.find(e, t)) == null ? void 0 : r.state.data;
  }
  ensureQueryData(e, t, r) {
    const n = D(e, t, r), i = this.getQueryData(n.queryKey);
    return i ? Promise.resolve(i) : this.fetchQuery(n);
  }
  getQueriesData(e) {
    return this.getQueryCache().findAll(e).map(({
      queryKey: t,
      state: r
    }) => {
      const n = r.data;
      return [t, n];
    });
  }
  setQueryData(e, t, r) {
    const n = this.queryCache.find(e), i = n == null ? void 0 : n.state.data, u = ze(t, i);
    if (typeof u > "u")
      return;
    const a = D(e), c = this.defaultQueryOptions(a);
    return this.queryCache.build(this, c).setData(u, {
      ...r,
      manual: !0
    });
  }
  setQueriesData(e, t, r) {
    return R.batch(() => this.getQueryCache().findAll(e).map(({
      queryKey: n
    }) => [n, this.setQueryData(n, t, r)]));
  }
  getQueryState(e, t) {
    var r;
    return (r = this.queryCache.find(e, t)) == null ? void 0 : r.state;
  }
  removeQueries(e, t) {
    const [r] = F(e, t), n = this.queryCache;
    R.batch(() => {
      n.findAll(r).forEach((i) => {
        n.remove(i);
      });
    });
  }
  resetQueries(e, t, r) {
    const [n, i] = F(e, t, r), u = this.queryCache, a = {
      type: "active",
      ...n
    };
    return R.batch(() => (u.findAll(n).forEach((c) => {
      c.reset();
    }), this.refetchQueries(a, i)));
  }
  cancelQueries(e, t, r) {
    const [n, i = {}] = F(e, t, r);
    typeof i.revert > "u" && (i.revert = !0);
    const u = R.batch(() => this.queryCache.findAll(n).map((a) => a.cancel(i)));
    return Promise.all(u).then(w).catch(w);
  }
  invalidateQueries(e, t, r) {
    const [n, i] = F(e, t, r);
    return R.batch(() => {
      var u, a;
      if (this.queryCache.findAll(n).forEach((l) => {
        l.invalidate();
      }), n.refetchType === "none")
        return Promise.resolve();
      const c = {
        ...n,
        type: (u = (a = n.refetchType) != null ? a : n.type) != null ? u : "active"
      };
      return this.refetchQueries(c, i);
    });
  }
  refetchQueries(e, t, r) {
    const [n, i] = F(e, t, r), u = R.batch(() => this.queryCache.findAll(n).filter((c) => !c.isDisabled()).map((c) => {
      var l;
      return c.fetch(void 0, {
        ...i,
        cancelRefetch: (l = i == null ? void 0 : i.cancelRefetch) != null ? l : !0,
        meta: {
          refetchPage: n.refetchPage
        }
      });
    }));
    let a = Promise.all(u).then(w);
    return i != null && i.throwOnError || (a = a.catch(w)), a;
  }
  fetchQuery(e, t, r) {
    const n = D(e, t, r), i = this.defaultQueryOptions(n);
    typeof i.retry > "u" && (i.retry = !1);
    const u = this.queryCache.build(this, i);
    return u.isStaleByTime(i.staleTime) ? u.fetch(i) : Promise.resolve(u.state.data);
  }
  prefetchQuery(e, t, r) {
    return this.fetchQuery(e, t, r).then(w).catch(w);
  }
  fetchInfiniteQuery(e, t, r) {
    const n = D(e, t, r);
    return n.behavior = X(), this.fetchQuery(n);
  }
  prefetchInfiniteQuery(e, t, r) {
    return this.fetchInfiniteQuery(e, t, r).then(w).catch(w);
  }
  resumePausedMutations() {
    return this.mutationCache.resumePausedMutations();
  }
  getQueryCache() {
    return this.queryCache;
  }
  getMutationCache() {
    return this.mutationCache;
  }
  getLogger() {
    return this.logger;
  }
  getDefaultOptions() {
    return this.defaultOptions;
  }
  setDefaultOptions(e) {
    this.defaultOptions = e;
  }
  setQueryDefaults(e, t) {
    const r = this.queryDefaults.find((n) => q(e) === q(n.queryKey));
    r ? r.defaultOptions = t : this.queryDefaults.push({
      queryKey: e,
      defaultOptions: t
    });
  }
  getQueryDefaults(e) {
    if (!e)
      return;
    const t = this.queryDefaults.find((r) => k(e, r.queryKey));
    return t == null ? void 0 : t.defaultOptions;
  }
  setMutationDefaults(e, t) {
    const r = this.mutationDefaults.find((n) => q(e) === q(n.mutationKey));
    r ? r.defaultOptions = t : this.mutationDefaults.push({
      mutationKey: e,
      defaultOptions: t
    });
  }
  getMutationDefaults(e) {
    if (!e)
      return;
    const t = this.mutationDefaults.find((r) => k(e, r.mutationKey));
    return t == null ? void 0 : t.defaultOptions;
  }
  defaultQueryOptions(e) {
    if (e != null && e._defaulted)
      return e;
    const t = {
      ...this.defaultOptions.queries,
      ...this.getQueryDefaults(e == null ? void 0 : e.queryKey),
      ...e,
      _defaulted: !0
    };
    return !t.queryHash && t.queryKey && (t.queryHash = re(t.queryKey, t)), typeof t.refetchOnReconnect > "u" && (t.refetchOnReconnect = t.networkMode !== "always"), typeof t.useErrorBoundary > "u" && (t.useErrorBoundary = !!t.suspense), t;
  }
  defaultMutationOptions(e) {
    return e != null && e._defaulted ? e : {
      ...this.defaultOptions.mutations,
      ...this.getMutationDefaults(e == null ? void 0 : e.mutationKey),
      ...e,
      _defaulted: !0
    };
  }
  clear() {
    this.queryCache.clear(), this.mutationCache.clear();
  }
}
class ne extends x {
  constructor(e, t) {
    super(), this.client = e, this.options = t, this.trackedProps = /* @__PURE__ */ new Set(), this.selectError = null, this.bindMethods(), this.setOptions(t);
  }
  bindMethods() {
    this.remove = this.remove.bind(this), this.refetch = this.refetch.bind(this);
  }
  onSubscribe() {
    this.listeners.size === 1 && (this.currentQuery.addObserver(this), pe(this.currentQuery, this.options) && this.executeFetch(), this.updateTimers());
  }
  onUnsubscribe() {
    this.hasListeners() || this.destroy();
  }
  shouldFetchOnReconnect() {
    return $(this.currentQuery, this.options, this.options.refetchOnReconnect);
  }
  shouldFetchOnWindowFocus() {
    return $(this.currentQuery, this.options, this.options.refetchOnWindowFocus);
  }
  destroy() {
    this.listeners = /* @__PURE__ */ new Set(), this.clearStaleTimeout(), this.clearRefetchInterval(), this.currentQuery.removeObserver(this);
  }
  setOptions(e, t) {
    const r = this.options, n = this.currentQuery;
    if (this.options = this.client.defaultQueryOptions(e), j(r, this.options) || this.client.getQueryCache().notify({
      type: "observerOptionsUpdated",
      query: this.currentQuery,
      observer: this
    }), typeof this.options.enabled < "u" && typeof this.options.enabled != "boolean")
      throw new Error("Expected enabled to be a boolean");
    this.options.queryKey || (this.options.queryKey = r.queryKey), this.updateQuery();
    const i = this.hasListeners();
    i && ve(this.currentQuery, n, this.options, r) && this.executeFetch(), this.updateResult(t), i && (this.currentQuery !== n || this.options.enabled !== r.enabled || this.options.staleTime !== r.staleTime) && this.updateStaleTimeout();
    const u = this.computeRefetchInterval();
    i && (this.currentQuery !== n || this.options.enabled !== r.enabled || u !== this.currentRefetchInterval) && this.updateRefetchInterval(u);
  }
  getOptimisticResult(e) {
    const t = this.client.getQueryCache().build(this.client, e), r = this.createResult(t, e);
    return lt(this, r, e) && (this.currentResult = r, this.currentResultOptions = this.options, this.currentResultState = this.currentQuery.state), r;
  }
  getCurrentResult() {
    return this.currentResult;
  }
  trackResult(e) {
    const t = {};
    return Object.keys(e).forEach((r) => {
      Object.defineProperty(t, r, {
        configurable: !1,
        enumerable: !0,
        get: () => (this.trackedProps.add(r), e[r])
      });
    }), t;
  }
  getCurrentQuery() {
    return this.currentQuery;
  }
  remove() {
    this.client.getQueryCache().remove(this.currentQuery);
  }
  refetch({
    refetchPage: e,
    ...t
  } = {}) {
    return this.fetch({
      ...t,
      meta: {
        refetchPage: e
      }
    });
  }
  fetchOptimistic(e) {
    const t = this.client.defaultQueryOptions(e), r = this.client.getQueryCache().build(this.client, t);
    return r.isFetchingOptimistic = !0, r.fetch().then(() => this.createResult(r, t));
  }
  fetch(e) {
    var t;
    return this.executeFetch({
      ...e,
      cancelRefetch: (t = e.cancelRefetch) != null ? t : !0
    }).then(() => (this.updateResult(), this.currentResult));
  }
  executeFetch(e) {
    this.updateQuery();
    let t = this.currentQuery.fetch(this.options, e);
    return e != null && e.throwOnError || (t = t.catch(w)), t;
  }
  updateStaleTimeout() {
    if (this.clearStaleTimeout(), K || this.currentResult.isStale || !J(this.options.staleTime))
      return;
    const t = Oe(this.currentResult.dataUpdatedAt, this.options.staleTime) + 1;
    this.staleTimeoutId = setTimeout(() => {
      this.currentResult.isStale || this.updateResult();
    }, t);
  }
  computeRefetchInterval() {
    var e;
    return typeof this.options.refetchInterval == "function" ? this.options.refetchInterval(this.currentResult.data, this.currentQuery) : (e = this.options.refetchInterval) != null ? e : !1;
  }
  updateRefetchInterval(e) {
    this.clearRefetchInterval(), this.currentRefetchInterval = e, !(K || this.options.enabled === !1 || !J(this.currentRefetchInterval) || this.currentRefetchInterval === 0) && (this.refetchIntervalId = setInterval(() => {
      (this.options.refetchIntervalInBackground || N.isFocused()) && this.executeFetch();
    }, this.currentRefetchInterval));
  }
  updateTimers() {
    this.updateStaleTimeout(), this.updateRefetchInterval(this.computeRefetchInterval());
  }
  clearStaleTimeout() {
    this.staleTimeoutId && (clearTimeout(this.staleTimeoutId), this.staleTimeoutId = void 0);
  }
  clearRefetchInterval() {
    this.refetchIntervalId && (clearInterval(this.refetchIntervalId), this.refetchIntervalId = void 0);
  }
  createResult(e, t) {
    const r = this.currentQuery, n = this.options, i = this.currentResult, u = this.currentResultState, a = this.currentResultOptions, c = e !== r, l = c ? e.state : this.currentQueryInitialState, h = c ? this.currentResult : this.previousQueryResult, {
      state: d
    } = e;
    let {
      dataUpdatedAt: f,
      error: o,
      errorUpdatedAt: y,
      fetchStatus: p,
      status: v
    } = d, C = !1, Q = !1, P;
    if (t._optimisticResults) {
      const m = this.hasListeners(), E = !m && pe(e, t), U = m && ve(e, r, t, n);
      (E || U) && (p = B(e.options.networkMode) ? "fetching" : "paused", f || (v = "loading")), t._optimisticResults === "isRestoring" && (p = "idle");
    }
    if (t.keepPreviousData && !d.dataUpdatedAt && h != null && h.isSuccess && v !== "error")
      P = h.data, f = h.dataUpdatedAt, v = h.status, C = !0;
    else if (t.select && typeof d.data < "u")
      if (i && d.data === (u == null ? void 0 : u.data) && t.select === this.selectFn)
        P = this.selectResult;
      else
        try {
          this.selectFn = t.select, P = t.select(d.data), P = Y(i == null ? void 0 : i.data, P, t), this.selectResult = P, this.selectError = null;
        } catch (m) {
          this.selectError = m;
        }
    else
      P = d.data;
    if (typeof t.placeholderData < "u" && typeof P > "u" && v === "loading") {
      let m;
      if (i != null && i.isPlaceholderData && t.placeholderData === (a == null ? void 0 : a.placeholderData))
        m = i.data;
      else if (m = typeof t.placeholderData == "function" ? t.placeholderData() : t.placeholderData, t.select && typeof m < "u")
        try {
          m = t.select(m), this.selectError = null;
        } catch (E) {
          this.selectError = E;
        }
      typeof m < "u" && (v = "success", P = Y(i == null ? void 0 : i.data, m, t), Q = !0);
    }
    this.selectError && (o = this.selectError, P = this.selectResult, y = Date.now(), v = "error");
    const S = p === "fetching", M = v === "loading", g = v === "error";
    return {
      status: v,
      fetchStatus: p,
      isLoading: M,
      isSuccess: v === "success",
      isError: g,
      isInitialLoading: M && S,
      data: P,
      dataUpdatedAt: f,
      error: o,
      errorUpdatedAt: y,
      failureCount: d.fetchFailureCount,
      failureReason: d.fetchFailureReason,
      errorUpdateCount: d.errorUpdateCount,
      isFetched: d.dataUpdateCount > 0 || d.errorUpdateCount > 0,
      isFetchedAfterMount: d.dataUpdateCount > l.dataUpdateCount || d.errorUpdateCount > l.errorUpdateCount,
      isFetching: S,
      isRefetching: S && !M,
      isLoadingError: g && d.dataUpdatedAt === 0,
      isPaused: p === "paused",
      isPlaceholderData: Q,
      isPreviousData: C,
      isRefetchError: g && d.dataUpdatedAt !== 0,
      isStale: ue(e, t),
      refetch: this.refetch,
      remove: this.remove
    };
  }
  updateResult(e) {
    const t = this.currentResult, r = this.createResult(this.currentQuery, this.options);
    if (this.currentResultState = this.currentQuery.state, this.currentResultOptions = this.options, j(r, t))
      return;
    this.currentResult = r;
    const n = {
      cache: !0
    }, i = () => {
      if (!t)
        return !0;
      const {
        notifyOnChangeProps: u
      } = this.options, a = typeof u == "function" ? u() : u;
      if (a === "all" || !a && !this.trackedProps.size)
        return !0;
      const c = new Set(a ?? this.trackedProps);
      return this.options.useErrorBoundary && c.add("error"), Object.keys(this.currentResult).some((l) => {
        const h = l;
        return this.currentResult[h] !== t[h] && c.has(h);
      });
    };
    (e == null ? void 0 : e.listeners) !== !1 && i() && (n.listeners = !0), this.notify({
      ...n,
      ...e
    });
  }
  updateQuery() {
    const e = this.client.getQueryCache().build(this.client, this.options);
    if (e === this.currentQuery)
      return;
    const t = this.currentQuery;
    this.currentQuery = e, this.currentQueryInitialState = e.state, this.previousQueryResult = this.currentResult, this.hasListeners() && (t == null || t.removeObserver(this), e.addObserver(this));
  }
  onQueryUpdate(e) {
    const t = {};
    e.type === "success" ? t.onSuccess = !e.manual : e.type === "error" && !_(e.error) && (t.onError = !0), this.updateResult(t), this.hasListeners() && this.updateTimers();
  }
  notify(e) {
    R.batch(() => {
      if (e.onSuccess) {
        var t, r, n, i;
        (t = (r = this.options).onSuccess) == null || t.call(r, this.currentResult.data), (n = (i = this.options).onSettled) == null || n.call(i, this.currentResult.data, null);
      } else if (e.onError) {
        var u, a, c, l;
        (u = (a = this.options).onError) == null || u.call(a, this.currentResult.error), (c = (l = this.options).onSettled) == null || c.call(l, void 0, this.currentResult.error);
      }
      e.listeners && this.listeners.forEach(({
        listener: h
      }) => {
        h(this.currentResult);
      }), e.cache && this.client.getQueryCache().notify({
        query: this.currentQuery,
        type: "observerResultsUpdated"
      });
    });
  }
}
function ct(s, e) {
  return e.enabled !== !1 && !s.state.dataUpdatedAt && !(s.state.status === "error" && e.retryOnMount === !1);
}
function pe(s, e) {
  return ct(s, e) || s.state.dataUpdatedAt > 0 && $(s, e, e.refetchOnMount);
}
function $(s, e, t) {
  if (e.enabled !== !1) {
    const r = typeof t == "function" ? t(s) : t;
    return r === "always" || r !== !1 && ue(s, e);
  }
  return !1;
}
function ve(s, e, t, r) {
  return t.enabled !== !1 && (s !== e || r.enabled === !1) && (!t.suspense || s.state.status !== "error") && ue(s, t);
}
function ue(s, e) {
  return s.isStaleByTime(e.staleTime);
}
function lt(s, e, t) {
  return t.keepPreviousData ? !1 : t.placeholderData !== void 0 ? e.isPlaceholderData : !j(s.getCurrentResult(), e);
}
class ht extends x {
  constructor(e, t) {
    super(), this.client = e, this.queries = [], this.result = [], this.observers = [], this.observersMap = {}, t && this.setQueries(t);
  }
  onSubscribe() {
    this.listeners.size === 1 && this.observers.forEach((e) => {
      e.subscribe((t) => {
        this.onUpdate(e, t);
      });
    });
  }
  onUnsubscribe() {
    this.listeners.size || this.destroy();
  }
  destroy() {
    this.listeners = /* @__PURE__ */ new Set(), this.observers.forEach((e) => {
      e.destroy();
    });
  }
  setQueries(e, t) {
    this.queries = e, R.batch(() => {
      const r = this.observers, n = this.findMatchingObservers(this.queries);
      n.forEach((l) => l.observer.setOptions(l.defaultedQueryOptions, t));
      const i = n.map((l) => l.observer), u = Object.fromEntries(i.map((l) => [l.options.queryHash, l])), a = i.map((l) => l.getCurrentResult()), c = i.some((l, h) => l !== r[h]);
      r.length === i.length && !c || (this.observers = i, this.observersMap = u, this.result = a, this.hasListeners() && (oe(r, i).forEach((l) => {
        l.destroy();
      }), oe(i, r).forEach((l) => {
        l.subscribe((h) => {
          this.onUpdate(l, h);
        });
      }), this.notify()));
    });
  }
  getCurrentResult() {
    return this.result;
  }
  getQueries() {
    return this.observers.map((e) => e.getCurrentQuery());
  }
  getObservers() {
    return this.observers;
  }
  getOptimisticResult(e) {
    return this.findMatchingObservers(e).map((t) => t.observer.getOptimisticResult(t.defaultedQueryOptions));
  }
  findMatchingObservers(e) {
    const t = this.observers, r = new Map(t.map((o) => [o.options.queryHash, o])), n = e.map((o) => this.client.defaultQueryOptions(o)), i = n.flatMap((o) => {
      const y = r.get(o.queryHash);
      return y != null ? [{
        defaultedQueryOptions: o,
        observer: y
      }] : [];
    }), u = new Set(i.map((o) => o.defaultedQueryOptions.queryHash)), a = n.filter((o) => !u.has(o.queryHash)), c = new Set(i.map((o) => o.observer)), l = t.filter((o) => !c.has(o)), h = (o) => {
      const y = this.client.defaultQueryOptions(o), p = this.observersMap[y.queryHash];
      return p ?? new ne(this.client, y);
    }, d = a.map((o, y) => {
      if (o.keepPreviousData) {
        const p = l[y];
        if (p !== void 0)
          return {
            defaultedQueryOptions: o,
            observer: p
          };
      }
      return {
        defaultedQueryOptions: o,
        observer: h(o)
      };
    }), f = (o, y) => n.indexOf(o.defaultedQueryOptions) - n.indexOf(y.defaultedQueryOptions);
    return i.concat(d).sort(f);
  }
  onUpdate(e, t) {
    const r = this.observers.indexOf(e);
    r !== -1 && (this.result = Ve(this.result, r, t), this.notify());
  }
  notify() {
    R.batch(() => {
      this.listeners.forEach(({
        listener: e
      }) => {
        e(this.result);
      });
    });
  }
}
class dt extends ne {
  // Type override
  // Type override
  // Type override
  // eslint-disable-next-line @typescript-eslint/no-useless-constructor
  constructor(e, t) {
    super(e, t);
  }
  bindMethods() {
    super.bindMethods(), this.fetchNextPage = this.fetchNextPage.bind(this), this.fetchPreviousPage = this.fetchPreviousPage.bind(this);
  }
  setOptions(e, t) {
    super.setOptions({
      ...e,
      behavior: X()
    }, t);
  }
  getOptimisticResult(e) {
    return e.behavior = X(), super.getOptimisticResult(e);
  }
  fetchNextPage({
    pageParam: e,
    ...t
  } = {}) {
    return this.fetch({
      ...t,
      meta: {
        fetchMore: {
          direction: "forward",
          pageParam: e
        }
      }
    });
  }
  fetchPreviousPage({
    pageParam: e,
    ...t
  } = {}) {
    return this.fetch({
      ...t,
      meta: {
        fetchMore: {
          direction: "backward",
          pageParam: e
        }
      }
    });
  }
  createResult(e, t) {
    var r, n, i, u, a, c;
    const {
      state: l
    } = e, h = super.createResult(e, t), {
      isFetching: d,
      isRefetching: f
    } = h, o = d && ((r = l.fetchMeta) == null || (n = r.fetchMore) == null ? void 0 : n.direction) === "forward", y = d && ((i = l.fetchMeta) == null || (u = i.fetchMore) == null ? void 0 : u.direction) === "backward";
    return {
      ...h,
      fetchNextPage: this.fetchNextPage,
      fetchPreviousPage: this.fetchPreviousPage,
      hasNextPage: at(t, (a = l.data) == null ? void 0 : a.pages),
      hasPreviousPage: ot(t, (c = l.data) == null ? void 0 : c.pages),
      isFetchingNextPage: o,
      isFetchingPreviousPage: y,
      isRefetching: f && !o && !y
    };
  }
}
class ft extends x {
  constructor(e, t) {
    super(), this.client = e, this.setOptions(t), this.bindMethods(), this.updateResult();
  }
  bindMethods() {
    this.mutate = this.mutate.bind(this), this.reset = this.reset.bind(this);
  }
  setOptions(e) {
    var t;
    const r = this.options;
    this.options = this.client.defaultMutationOptions(e), j(r, this.options) || this.client.getMutationCache().notify({
      type: "observerOptionsUpdated",
      mutation: this.currentMutation,
      observer: this
    }), (t = this.currentMutation) == null || t.setOptions(this.options);
  }
  onUnsubscribe() {
    if (!this.hasListeners()) {
      var e;
      (e = this.currentMutation) == null || e.removeObserver(this);
    }
  }
  onMutationUpdate(e) {
    this.updateResult();
    const t = {
      listeners: !0
    };
    e.type === "success" ? t.onSuccess = !0 : e.type === "error" && (t.onError = !0), this.notify(t);
  }
  getCurrentResult() {
    return this.currentResult;
  }
  reset() {
    this.currentMutation = void 0, this.updateResult(), this.notify({
      listeners: !0
    });
  }
  mutate(e, t) {
    return this.mutateOptions = t, this.currentMutation && this.currentMutation.removeObserver(this), this.currentMutation = this.client.getMutationCache().build(this.client, {
      ...this.options,
      variables: typeof e < "u" ? e : this.options.variables
    }), this.currentMutation.addObserver(this), this.currentMutation.execute();
  }
  updateResult() {
    const e = this.currentMutation ? this.currentMutation.state : we(), t = {
      ...e,
      isLoading: e.status === "loading",
      isSuccess: e.status === "success",
      isError: e.status === "error",
      isIdle: e.status === "idle",
      mutate: this.mutate,
      reset: this.reset
    };
    this.currentResult = t;
  }
  notify(e) {
    R.batch(() => {
      if (this.mutateOptions && this.hasListeners()) {
        if (e.onSuccess) {
          var t, r, n, i;
          (t = (r = this.mutateOptions).onSuccess) == null || t.call(r, this.currentResult.data, this.currentResult.variables, this.currentResult.context), (n = (i = this.mutateOptions).onSettled) == null || n.call(i, this.currentResult.data, null, this.currentResult.variables, this.currentResult.context);
        } else if (e.onError) {
          var u, a, c, l;
          (u = (a = this.mutateOptions).onError) == null || u.call(a, this.currentResult.error, this.currentResult.variables, this.currentResult.context), (c = (l = this.mutateOptions).onSettled) == null || c.call(l, void 0, this.currentResult.error, this.currentResult.variables, this.currentResult.context);
        }
      }
      e.listeners && this.listeners.forEach(({
        listener: h
      }) => {
        h(this.currentResult);
      });
    });
  }
}
function yt(s) {
  return {
    mutationKey: s.options.mutationKey,
    state: s.state
  };
}
function pt(s) {
  return {
    state: s.state,
    queryKey: s.queryKey,
    queryHash: s.queryHash
  };
}
function vt(s) {
  return s.state.isPaused;
}
function mt(s) {
  return s.state.status === "success";
}
function Dt(s, e = {}) {
  const t = [], r = [];
  if (e.dehydrateMutations !== !1) {
    const n = e.shouldDehydrateMutation || vt;
    s.getMutationCache().getAll().forEach((i) => {
      n(i) && t.push(yt(i));
    });
  }
  if (e.dehydrateQueries !== !1) {
    const n = e.shouldDehydrateQuery || mt;
    s.getQueryCache().getAll().forEach((i) => {
      n(i) && r.push(pt(i));
    });
  }
  return {
    mutations: t,
    queries: r
  };
}
function bt(s, e, t) {
  if (typeof e != "object" || e === null)
    return;
  const r = s.getMutationCache(), n = s.getQueryCache(), i = e.mutations || [], u = e.queries || [];
  i.forEach((a) => {
    var c;
    r.build(s, {
      ...t == null || (c = t.defaultOptions) == null ? void 0 : c.mutations,
      mutationKey: a.mutationKey
    }, a.state);
  }), u.forEach(({
    queryKey: a,
    state: c,
    queryHash: l
  }) => {
    var h;
    const d = n.get(l);
    if (d) {
      if (d.state.dataUpdatedAt < c.dataUpdatedAt) {
        const {
          fetchStatus: f,
          ...o
        } = c;
        d.setState(o);
      }
      return;
    }
    n.build(
      s,
      {
        ...t == null || (h = t.defaultOptions) == null ? void 0 : h.queries,
        queryKey: a,
        queryHash: l
      },
      // Reset fetch status to idle to avoid
      // query being stuck in fetching state upon hydration
      {
        ...c,
        fetchStatus: "idle"
      }
    );
  });
}
var Fe = { exports: {} }, V = {};
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var me;
function gt() {
  if (me) return V;
  me = 1;
  var s = se;
  function e(d, f) {
    return d === f && (d !== 0 || 1 / d === 1 / f) || d !== d && f !== f;
  }
  var t = typeof Object.is == "function" ? Object.is : e, r = s.useState, n = s.useEffect, i = s.useLayoutEffect, u = s.useDebugValue;
  function a(d, f) {
    var o = f(), y = r({ inst: { value: o, getSnapshot: f } }), p = y[0].inst, v = y[1];
    return i(function() {
      p.value = o, p.getSnapshot = f, c(p) && v({ inst: p });
    }, [d, o, f]), n(function() {
      return c(p) && v({ inst: p }), d(function() {
        c(p) && v({ inst: p });
      });
    }, [d]), u(o), o;
  }
  function c(d) {
    var f = d.getSnapshot;
    d = d.value;
    try {
      var o = f();
      return !t(d, o);
    } catch {
      return !0;
    }
  }
  function l(d, f) {
    return f();
  }
  var h = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? l : a;
  return V.useSyncExternalStore = s.useSyncExternalStore !== void 0 ? s.useSyncExternalStore : h, V;
}
Fe.exports = gt();
var Ot = Fe.exports;
const L = Ot.useSyncExternalStore, be = /* @__PURE__ */ O.createContext(void 0), qe = /* @__PURE__ */ O.createContext(!1);
function xe(s, e) {
  return s || (e && typeof window < "u" ? (window.ReactQueryClientContext || (window.ReactQueryClientContext = be), window.ReactQueryClientContext) : be);
}
const I = ({
  context: s
} = {}) => {
  const e = O.useContext(xe(s, O.useContext(qe)));
  if (!e)
    throw new Error("No QueryClient set, use QueryClientProvider to set one");
  return e;
}, Rt = ({
  client: s,
  children: e,
  context: t,
  contextSharing: r = !1
}) => {
  O.useEffect(() => (s.mount(), () => {
    s.unmount();
  }), [s]);
  const n = xe(t, r);
  return /* @__PURE__ */ O.createElement(qe.Provider, {
    value: !t && r
  }, /* @__PURE__ */ O.createElement(n.Provider, {
    value: s
  }, e));
}, De = /* @__PURE__ */ O.createContext(!1), Ae = () => O.useContext(De), At = De.Provider;
function Ie() {
  let s = !1;
  return {
    clearReset: () => {
      s = !1;
    },
    reset: () => {
      s = !0;
    },
    isReset: () => s
  };
}
const Ue = /* @__PURE__ */ O.createContext(Ie()), Te = () => O.useContext(Ue), It = ({
  children: s
}) => {
  const [e] = O.useState(() => Ie());
  return /* @__PURE__ */ O.createElement(Ue.Provider, {
    value: e
  }, typeof s == "function" ? s(e) : s);
};
function Ke(s, e) {
  return typeof s == "function" ? s(...e) : !!s;
}
const Le = (s, e) => {
  (s.suspense || s.useErrorBoundary) && (e.isReset() || (s.retryOnMount = !1));
}, _e = (s) => {
  O.useEffect(() => {
    s.clearReset();
  }, [s]);
}, ke = ({
  result: s,
  errorResetBoundary: e,
  useErrorBoundary: t,
  query: r
}) => s.isError && !e.isReset() && !s.isFetching && Ke(t, [s.error, r]), je = (s) => {
  s.suspense && typeof s.staleTime != "number" && (s.staleTime = 1e3);
}, Ne = (s, e) => s.isLoading && s.isFetching && !e, ee = (s, e, t) => (s == null ? void 0 : s.suspense) && Ne(e, t), te = (s, e, t) => e.fetchOptimistic(s).then(({
  data: r
}) => {
  s.onSuccess == null || s.onSuccess(r), s.onSettled == null || s.onSettled(r, null);
}).catch((r) => {
  t.clearReset(), s.onError == null || s.onError(r), s.onSettled == null || s.onSettled(void 0, r);
});
function Ut({
  queries: s,
  context: e
}) {
  const t = I({
    context: e
  }), r = Ae(), n = Te(), i = O.useMemo(() => s.map((f) => {
    const o = t.defaultQueryOptions(f);
    return o._optimisticResults = r ? "isRestoring" : "optimistic", o;
  }), [s, t, r]);
  i.forEach((f) => {
    je(f), Le(f, n);
  }), _e(n);
  const [u] = O.useState(() => new ht(t, i)), a = u.getOptimisticResult(i);
  L(O.useCallback((f) => r ? () => {
  } : u.subscribe(R.batchCalls(f)), [u, r]), () => u.getCurrentResult(), () => u.getCurrentResult()), O.useEffect(() => {
    u.setQueries(i, {
      listeners: !1
    });
  }, [i, u]);
  const l = a.some((f, o) => ee(i[o], f, r)) ? a.flatMap((f, o) => {
    const y = i[o], p = u.getObservers()[o];
    if (y && p) {
      if (ee(y, f, r))
        return te(y, p, n);
      Ne(f, r) && te(y, p, n);
    }
    return [];
  }) : [];
  if (l.length > 0)
    throw Promise.all(l);
  const h = u.getQueries(), d = a.find((f, o) => {
    var y, p;
    return ke({
      result: f,
      errorResetBoundary: n,
      useErrorBoundary: (y = (p = i[o]) == null ? void 0 : p.useErrorBoundary) != null ? y : !1,
      query: h[o]
    });
  });
  if (d != null && d.error)
    throw d.error;
  return a;
}
function He(s, e) {
  const t = I({
    context: s.context
  }), r = Ae(), n = Te(), i = t.defaultQueryOptions(s);
  i._optimisticResults = r ? "isRestoring" : "optimistic", i.onError && (i.onError = R.batchCalls(i.onError)), i.onSuccess && (i.onSuccess = R.batchCalls(i.onSuccess)), i.onSettled && (i.onSettled = R.batchCalls(i.onSettled)), je(i), Le(i, n), _e(n);
  const [u] = O.useState(() => new e(t, i)), a = u.getOptimisticResult(i);
  if (L(O.useCallback((c) => {
    const l = r ? () => {
    } : u.subscribe(R.batchCalls(c));
    return u.updateResult(), l;
  }, [u, r]), () => u.getCurrentResult(), () => u.getCurrentResult()), O.useEffect(() => {
    u.setOptions(i, {
      listeners: !1
    });
  }, [i, u]), ee(i, a, r))
    throw te(i, u, n);
  if (ke({
    result: a,
    errorResetBoundary: n,
    useErrorBoundary: i.useErrorBoundary,
    query: u.getCurrentQuery()
  }))
    throw a.error;
  return i.notifyOnChangeProps ? a : u.trackResult(a);
}
function Ct(s, e, t) {
  const r = D(s, e, t);
  return He(r, ne);
}
function Pt(s, e = {}) {
  const t = I({
    context: e.context
  }), r = O.useRef(e);
  r.current = e, O.useMemo(() => {
    s && bt(t, s, r.current);
  }, [t, s]);
}
const Tt = ({
  children: s,
  options: e,
  state: t
}) => (Pt(t, e), s);
function Kt(s, e, t) {
  const [r, n = {}] = F(s, e, t), i = I({
    context: n.context
  }), u = i.getQueryCache();
  return L(O.useCallback((a) => u.subscribe(R.batchCalls(a)), [u]), () => i.isFetching(r), () => i.isFetching(r));
}
function Lt(s, e, t) {
  const [r, n = {}] = We(s, e, t), i = I({
    context: n.context
  }), u = i.getMutationCache();
  return L(O.useCallback((a) => u.subscribe(R.batchCalls(a)), [u]), () => i.isMutating(r), () => i.isMutating(r));
}
function St(s, e, t) {
  const r = Je(s, e, t), n = I({
    context: r.context
  }), [i] = O.useState(() => new ft(n, r));
  O.useEffect(() => {
    i.setOptions(r);
  }, [i, r]);
  const u = L(O.useCallback((c) => i.subscribe(R.batchCalls(c)), [i]), () => i.getCurrentResult(), () => i.getCurrentResult()), a = O.useCallback((c, l) => {
    i.mutate(c, l).catch(Qt);
  }, [i]);
  if (u.error && Ke(i.options.useErrorBoundary, [u.error]))
    throw u.error;
  return {
    ...u,
    mutate: a,
    mutateAsync: u.mutate
  };
}
function Qt() {
}
function _t(s, e, t) {
  const r = D(s, e, t);
  return He(r, dt);
}
const Et = function() {
  return null;
}, wt = se.lazy(() => import("./index.prod-COBLi686.js").then((s) => ({
  default: s.ReactQueryDevtools
}))), kt = ({
  queryClient: s,
  children: e,
  showDevtools: t
}) => /* @__PURE__ */ z.jsxs(Rt, { client: s, children: [
  t && /* @__PURE__ */ z.jsx(wt, {}),
  /* @__PURE__ */ z.jsx(Et, {}),
  e
] });
function jt(s, e, t) {
  return Ct(s, e, t);
}
function Nt(s, e, t) {
  return St(s, e, t);
}
export {
  ce as A,
  F as B,
  Se as C,
  Je as D,
  We as E,
  D as F,
  Ce as G,
  Tt as H,
  At as I,
  vt as J,
  mt as K,
  Dt as L,
  ut as M,
  bt as N,
  tt as O,
  kt as Q,
  jt as a,
  Nt as b,
  Ut as c,
  be as d,
  Pt as e,
  It as f,
  Te as g,
  Kt as h,
  Lt as i,
  _t as j,
  Ae as k,
  _ as l,
  rt as m,
  R as n,
  H as o,
  xt as p,
  ne as q,
  ht as r,
  Ot as s,
  dt as t,
  I as u,
  ft as v,
  N as w,
  q as x,
  qt as y,
  K as z
};
